export const actions = {
  SHOW_APP_LOADING: 'SHOW_APP_LOADING',
  HIDE_APP_LOADING: 'HIDE_APP_LOADING',
  SHOW_ALERT_MSG: 'SHOW_ALERT_MSG',
  CLEAR_ALERT_MSG: 'CLEAR_ALERT_MSG',
  SAVE_USER_INFO_ACTION: 'SAVE_USER_INFO_ACTION',
  FETCH_USER_INFO_ACTION: 'FETCH_USER_INFO_ACTION',
  SIGN_OUT_ACTION: 'SIGN_OUT_ACTION',
  INITIAL_CALL: 'INITIAL_CALL',
  FETCH_APP_DATA: 'FETCH_APP_DATA',
  FETCH_ORG_DATA: 'FETCH_ORG_DATA',
  SAVE_ORG_DATA: 'SAVE_ORG_DATA',
  SAVE_ORG_DATA_IN_STATE: 'SAVE_ORG_DATA_IN_STATE',
  FETCH_TEAMS_DATA: 'FETCH_TEAMS_DATA',
  FETCH_USER_TEAMS_DATA: 'FETCH_USER_TEAMS_DATA',
  SAVE_COMPANY_TEAMS_LIST: 'SAVE_COMPANY_TEAMS_LIST',
  SAVE_COMPANY_TAGS_LIST: 'SAVE_COMPANY_TAGS_LIST',
  SAVE_USER_TEAMS_DATA: 'SAVE_USER_TEAMS_DATA',
  CREATE_TEAM_REQUEST: 'CREATE_TEAM_REQUEST',
  SAVE_RECENTLY_CREATE_TEAM: 'SAVE_RECENTLY_CREATE_TEAM',
  SHOW_CHANGE_ORG_DIALOG: 'SHOW_CHANGE_ORG_DIALOG',
  CONFIRM_CHANGE_ORG: 'CONFIRM_CHANGE_ORG',
  CLEAR_ALL_DATA: 'CLEAR_ALL_DATA',
  SAVE_NOTIFICATION_PREFERENCE: 'SAVE_NOTIFICATION_PREFERENCE',
  UPDATE_DROPDOWN_STATE: 'UPDATE_DROPDOWN_STATE',
  SAVE_HIGHLIGHTED_OBJECTIVE: 'SAVE_HIGHLIGHTED_OBJECTIVE',
  CLEAR_HIGHLIGHTED_OBJECTIVE: 'CLEAR_HIGHLIGHTED_OBJECTIVE',
  SHOW_FEATURE_TOOLTIP_ACTION: 'SHOW_FEATURE_TOOLTIP_ACTION',
  SAVE_TOOLTIP_INFO: 'SAVE_TOOLTIP_INFO',
  SAVE_USER_ORGS_ACTION: 'SAVE_USER_ORGS_ACTION',
  FETCH_USER_ORGS_ACTION: 'FETCH_USER_ORGS_ACTION',
  CLEAR_ORG_DATA: 'CLEAR_ORG_DATA',
  RESET_REDUCER: 'RESET_REDUCER',
  UPDATE_TASK_PANEL_OPEN_STATE: 'UPDATE_TASK_PANEL_OPEN_STATE',
  ENABLE_SEARCH_ACTION: 'ENABLE_SEARCH_ACTION',
  DISABLE_SEARCH_ACTION: 'DISABLE_SEARCH_ACTION',
  RESET_SEARCH_STATE_ACTION: 'RESET_SEARCH_STATE_ACTION',
  SAVE_INTEGRATIONS_ACTION: 'SAVE_INTEGRATIONS_ACTION',
  REGISTER_USER_ACCESS_ACTION: 'REGISTER_USER_ACCESS_ACTION',
  FETCH_OBJECTIVES_FOR_SELECTED_PARAMS: 'FETCH_OBJECTIVES_FOR_SELECTED_PARAMS',
  FETCH_COMPANY_TAGS_DATA: 'FETCH_COMPANY_TAGS_DATA',
  CREATE_TAG_REQUEST: 'CREATE_TAG_REQUEST',
  FETCH_MANAGEABLE_TAGS: 'FETCH_MANAGEABLE_TAGS',
  SAVE_MANAGEABLE_TAGS: 'SAVE_MANAGEABLE_TAGS',
  UPDATE_TAGS: 'UPDATE_TAGS',
  SET_RTU_EVENT_STREAM: 'SET_RTU_EVENT_STREAM',
  IS_NEW_APP_VERSION_AVAILABLE: 'IS_NEW_APP_VERSION_AVAILABLE',
  SHOW_NEW_VERSION_AVAILABLE_ALERT_MSG: 'SHOW_NEW_VERSION_AVAILABLE_ALERT_MSG',
  MARK_MOBILE_BOTTOM_SHEET_AS_OPEN: 'MARK_MOBILE_BOTTOM_SHEET_AS_OPEN',
  MARK_MOBILE_BOTTOM_SHEET_AS_CLOSE: 'MARK_MOBILE_BOTTOM_SHEET_AS_CLOSE',
  SAVE_GOAL_STRENGTH_SCORES: 'SAVE_GOAL_STRENGTH_SCORES',
  HANDLE_API_CALL_ERROR: 'HANDLE_API_CALL_ERROR',
  UPDATE_IS_ANNUAL_GOALS_SPACE: 'UPDATE_IS_ANNUAL_GOALS_SPACE',
  FETCH_ORG_SETTINGS: 'FETCH_ORG_SETTINGS',
  UPDATE_ORG_SETTINGS: 'UPDATE_ORG_SETTINGS',
  SET_OBJECTIVE_CONFIG: 'SET_OBJECTIVE_CONFIG',
  FETCH_ORG_DIRECT_REPORTEES: 'FETCH_ORG_DIRECT_REPORTEES',
  SET_ORG_DIRECT_REPORTEES: 'SET_ORG_DIRECT_REPORTEES',
  SET_ORG_HIERARCHY: 'SET_ORG_HIERARCHY',
  SET_ACCESSIBLE_MODULES: 'SET_ACCESSIBLE_MODULES',
  SET_ORG_ACCESSIBLE_MODULES: 'SET_ORG_ACCESSIBLE_MODULES',
  FETCH_USER_MODULES: 'FETCH_USER_MODULES',
  FETCH_ORG_ACCESSIBLE_MODULES: 'FETCH_ORG_ACCESSIBLE_MODULES',
  SET_USER_ROLES: 'SET_USER_ROLES',
  SET_CURRENT_USER_VIEW_DETAILS: 'SET_CURRENT_USER_VIEW_DETAILS',
  SET_NEW_APP_REDIRECTION_CONFIG: 'SET_NEW_APP_REDIRECTION_CONFIG',
  FETCH_OKR_MODULE_DATA: 'FETCH_OKR_MODULE_DATA',
  SET_FETCHED_OKR_MODULE_DATA: 'SET_FETCHED_OKR_MODULE_DATA',
  SET_IS_USER_MANAGER: 'SET_IS_USER_MANAGER',
  SET_IS_USER_HRBP: 'SET_IS_USER_HRBP',
  SET_IS_USER_LINE_MANAGER: 'SET_IS_USER_LINE_MANAGER',
  SHOW_OKR_HIERARCHY_ALERT_MESSAGE: 'SHOW_OKR_HIERARCHY_ALERT_MESSAGE',
  CLEAR_OKR_HIERARCHY_ALERT_MESSAGE: 'CLEAR_OKR_HIERARCHY_ALERT_MESSAGE',
  SET_FULLSCREEN_HANDLER: 'SET_FULLSCREEN_HANDLER',
  HANDLE_HOME_BUTTON_CLICK: 'HANDLE_HOME_BUTTON_CLICK',
  SET_CURRENT_USER_HIERARCHY_LEVEL: 'SET_CURRENT_USER_HIERARCHY_LEVEL',
  FETCH_CURRENT_USER_HRBP_DETAILS: 'FETCH_CURRENT_USER_HRBP_DETAILS',
  SET_CURRENT_USER_HRBP_DETAILS: 'SET_CURRENT_USER_HRBP_DETAILS',
  FETCH_CURRENT_USER_REPORTEES_BY_PERSONA:
    'FETCH_CURRENT_USER_REPORTEES_BY_PERSONA',
  SET_CURRENT_USER_REPORTEES_BY_PERSONA:
    'SET_CURRENT_USER_REPORTEES_BY_PERSONA',
  SET_OBJECTIVE_OPERATIONS_LIST: 'SET_OBJECTIVE_OPERATIONS_LIST',
  FETCH_USER_PREFERENCES: 'FETCH_USER_PREFERENCES'
};

export const showAppLoading = () => ({
  type: actions.SHOW_APP_LOADING
});

export const hideAppLoading = () => ({
  type: actions.HIDE_APP_LOADING
});

export const showAlertMessage = (
  alertType,
  alertMessage,
  alertAction = null,
  parseMessage = false,
  customTime
) => ({
  type: actions.SHOW_ALERT_MSG,
  alertType,
  alertMessage,
  alertAction,
  parseMessage,
  customTime
});

export const clearAlertMessage = () => ({
  type: actions.CLEAR_ALERT_MSG
});

export const showNewVersionAvailableAlertMessage = (
  // new action for this alert so that this alert doesn't go away even after we get other alerts
  alertType,
  alertMessage,
  alertAction = null,
  parseMessage = false,
  customTime
) => ({
  type: actions.SHOW_NEW_VERSION_AVAILABLE_ALERT_MSG,
  alertType,
  alertMessage,
  alertAction,
  parseMessage,
  customTime
});

export const showOKRHierarchyAlertMessage = (
  // new action for this alert so that this alert doesn't go away even after we get other alerts and this doesn't overwrite new version alert
  alertType,
  alertMessage,
  alertAction = null,
  parseMessage = false,
  customTime
) => ({
  type: actions.SHOW_OKR_HIERARCHY_ALERT_MESSAGE,
  alertType,
  alertMessage,
  alertAction,
  parseMessage,
  customTime
});

export const clearOKRHierarchyAlertMessage = () => ({
  type: actions.CLEAR_OKR_HIERARCHY_ALERT_MESSAGE
});

export const saveUserInfoAction = userInfo => ({
  type: actions.SAVE_USER_INFO_ACTION,
  userInfo
});

export const fetchUserOrgsAction = () => ({
  type: actions.FETCH_USER_ORGS_ACTION
});

export const saveUserOrgsAction = userOrgs => ({
  type: actions.SAVE_USER_ORGS_ACTION,
  userOrgs
});

export const fetchUserInfoAction = () => ({
  type: actions.FETCH_USER_INFO_ACTION
});

export const signOutAction = (showToast = true) => ({
  type: actions.SIGN_OUT_ACTION,
  showToast
});

export const clearAllReducer = (resetIsAuthenticated = true) => ({
  type: actions.RESET_REDUCER,
  resetIsAuthenticated
});

export const initialCall = hideLoader => ({
  type: actions.INITIAL_CALL,
  hideLoader
});

export const fetchAppData = () => ({
  type: actions.FETCH_APP_DATA
});

export const fetchOrgData = subdomain => ({
  type: actions.FETCH_ORG_DATA,
  subdomain
});

export const saveOrgData = org => ({
  type: actions.SAVE_ORG_DATA,
  org
});

export const saveOrgDataInState = org => ({
  type: actions.SAVE_ORG_DATA_IN_STATE,
  org
});

export const fetchTeamsData = (teamType, selectedTeamId) => ({
  type: actions.FETCH_TEAMS_DATA,
  teamType,
  selectedTeamId
});

export const saveCompanyTeamsList = companyTeamsList => ({
  type: actions.SAVE_COMPANY_TEAMS_LIST,
  companyTeamsList
});

export const saveCompanyTagsList = companyTagsList => ({
  type: actions.SAVE_COMPANY_TAGS_LIST,
  companyTagsList
});

export const fetchManageableTags = () => ({
  type: actions.FETCH_MANAGEABLE_TAGS
});

export const saveManageableTags = tagsList => ({
  type: actions.SAVE_MANAGEABLE_TAGS,
  tagsList
});

export const updateTags = (requestBody, callback) => ({
  type: actions.UPDATE_TAGS,
  requestBody,
  callback
});

export const fetchCompanyTagsList = () => ({
  type: actions.FETCH_COMPANY_TAGS_DATA
});

export const saveUserTeamsData = userTeamsData => ({
  type: actions.SAVE_USER_TEAMS_DATA,
  userTeamsData
});

export const createTeamRequest = (
  label,
  description,
  owners,
  followers,
  selectedTeam,
  callback
) => ({
  type: actions.CREATE_TEAM_REQUEST,
  label,
  description,
  owners,
  followers,
  selectedTeam,
  callback
});

export const saveRecentlyCreatedTeam = team_id => ({
  type: actions.SAVE_RECENTLY_CREATE_TEAM,
  team_id
});

export const createTagRequest = (label, isTag, callback) => ({
  type: actions.CREATE_TAG_REQUEST,
  label,
  isTag,
  callback
});

export const setDiffOrgData = (data = {}) => ({
  type: actions.SHOW_CHANGE_ORG_DIALOG,
  data
});

export const confirmChangeOrg = orgName => ({
  type: actions.CONFIRM_CHANGE_ORG,
  orgName
});

export const clearAllData = (persistUserInfo = false) => ({
  type: actions.CLEAR_ALL_DATA,
  persistUserInfo
});

export const clearOrgData = () => ({
  type: actions.CLEAR_ORG_DATA
});

export const saveNotificationPreferences = data => ({
  type: actions.SAVE_NOTIFICATION_PREFERENCE,
  data
});

export const updateDropDownStateAction = data => ({
  type: actions.UPDATE_DROPDOWN_STATE,
  data
});

export const saveHighlightedObjective = (requestBody, blink) => ({
  type: actions.SAVE_HIGHLIGHTED_OBJECTIVE,
  requestBody,
  blink
});

export const clearHighlightedObjective = objective => ({
  type: actions.CLEAR_HIGHLIGHTED_OBJECTIVE,
  objective
});

export const fetchShouldShowFeatureTooltip = requestBody => ({
  type: actions.SHOW_FEATURE_TOOLTIP_ACTION,
  requestBody
});

export const saveTooltipInfo = data => ({
  type: actions.SAVE_TOOLTIP_INFO,
  data
});

export const setEnableSearch = search_term => ({
  type: actions.ENABLE_SEARCH_ACTION,
  search_term
});

export const updateTaskPanelOpenState = state => ({
  type: actions.UPDATE_TASK_PANEL_OPEN_STATE,
  state
});

export const setDisableSearch = () => ({
  type: actions.DISABLE_SEARCH_ACTION
});

export const resetSearchParamsAction = () => ({
  type: actions.RESET_SEARCH_STATE_ACTION
});

export const saveIntegrations = integrations => ({
  type: actions.SAVE_INTEGRATIONS_ACTION,
  integrations
});

export const registerUserAccess = () => ({
  type: actions.REGISTER_USER_ACCESS_ACTION
});

export const fetchObjectivesForSelectedParams = (
  shouldApplyFilter,
  appendObjectives = false,
  disablePagination = false,
  callback
) => ({
  type: actions.FETCH_OBJECTIVES_FOR_SELECTED_PARAMS,
  shouldApplyFilter,
  appendObjectives,
  disablePagination,
  callback
});

export const setRealTimeUpdatesEventStream = eventStream => ({
  type: actions.SET_RTU_EVENT_STREAM,
  eventStream
});

export const isNewAppVersionAvailable = value => ({
  type: actions.IS_NEW_APP_VERSION_AVAILABLE,
  value
});

export const markMobileBottomSheetAsOpen = () => ({
  type: actions.MARK_MOBILE_BOTTOM_SHEET_AS_OPEN
});

export const markMobileBottomSheetAsClosed = () => ({
  type: actions.MARK_MOBILE_BOTTOM_SHEET_AS_CLOSE
});

export const saveGoalStrengthScores = goalStrengthScoreSchema => ({
  type: actions.SAVE_GOAL_STRENGTH_SCORES,
  goalStrengthScoreSchema
});

export const handleApiCallError = (error, actionData) => ({
  type: actions.HANDLE_API_CALL_ERROR,
  error,
  actionData
});

export const updateIsAnnualGoalsSpace = status => ({
  type: actions.UPDATE_IS_ANNUAL_GOALS_SPACE,
  status
});

export const fetchOrgSettings = () => ({
  type: actions.FETCH_ORG_SETTINGS
});

export const updateOrgSettings = (requestBody, isEmployeeSettingsUpdated) => ({
  type: actions.UPDATE_ORG_SETTINGS,
  requestBody,
  isEmployeeSettingsUpdated
});

export const setObjectiveConfig = data => ({
  type: actions.SET_OBJECTIVE_CONFIG,
  data
});

export const setObjectiveOperationsList = data => ({
  type: actions.SET_OBJECTIVE_OPERATIONS_LIST,
  data
});

export const fetchOrgDirectReportees = () => ({
  type: actions.FETCH_ORG_DIRECT_REPORTEES
});

export const setOrgDirectReportees = directReportees => ({
  type: actions.SET_ORG_DIRECT_REPORTEES,
  directReportees
});

export const setOrgHierarchy = (managers, reportees) => ({
  type: actions.SET_ORG_HIERARCHY,
  managers,
  reportees
});

export const setAccessibleModules = (accessibleModules, visibleModules) => ({
  type: actions.SET_ACCESSIBLE_MODULES,
  accessibleModules,
  visibleModules
});

export const setOrgAccessibleModules = modules => ({
  type: actions.SET_ORG_ACCESSIBLE_MODULES,
  modules
});

export const fetchUserModules = user_reference_id => ({
  type: actions.FETCH_USER_MODULES,
  user_reference_id
});

export const fetchOrgModules = () => ({
  type: actions.FETCH_ORG_ACCESSIBLE_MODULES
});

export const setUserRoles = roles => ({
  type: actions.SET_USER_ROLES,
  roles
});

export const setCurrentUserViewDetails = view => ({
  type: actions.SET_CURRENT_USER_VIEW_DETAILS,
  view
});

export const setNewAppRedirectionConfig = config => ({
  type: actions.SET_NEW_APP_REDIRECTION_CONFIG,
  config
});

export const fetchOKRModuleData = (showLoading = true) => ({
  type: actions.FETCH_OKR_MODULE_DATA,
  showLoading
});

export const setFetchedOKRModuleData = state => ({
  type: actions.SET_FETCHED_OKR_MODULE_DATA,
  state
});

export const saveIsUserManager = data => ({
  type: actions.SET_IS_USER_MANAGER,
  data
});

export const saveIsUserLineManager = data => ({
  type: actions.SET_IS_USER_LINE_MANAGER,
  data
});

export const saveIsUserHrbp = data => ({
  type: actions.SET_IS_USER_HRBP,
  data
});

export const setCurrentUserHierarchyLevel = data => ({
  type: actions.SET_CURRENT_USER_HIERARCHY_LEVEL,
  data
});

export const setFullscreenHandler = state => ({
  type: actions.SET_FULLSCREEN_HANDLER,
  state
});

export const handleHomeButtonClick = () => ({
  type: actions.HANDLE_HOME_BUTTON_CLICK
});

export const fetchCurrentUserHrbpDetails = userReferenceId => ({
  type: actions.FETCH_CURRENT_USER_HRBP_DETAILS,
  userReferenceId
});

export const setCurrentUserHrbpDetails = data => ({
  type: actions.SET_CURRENT_USER_HRBP_DETAILS,
  data
});

export const fetchCurrentUserReporteesByPersona = personas => ({
  // personas : Personas[] -> Personas -> HRBP, ADMIN etc
  type: actions.FETCH_CURRENT_USER_REPORTEES_BY_PERSONA,
  personas
});

export const setCurrentUserReporteesByPersona = data => ({
  type: actions.SET_CURRENT_USER_REPORTEES_BY_PERSONA,
  data
});

export const fetchUserPreferences = () => ({
  type: actions.FETCH_USER_PREFERENCES
});
